import { ShieldCheck, CalendarClock } from "lucide-react";

export const PATENT_APP_NO = "GB2613313.2";
// 12 months from the UK priority filing (09 Jun 2026) to file the combined PCT.
export const PATENT_PCT_DEADLINE = "2027-06-09";

export const pctDaysRemaining = () =>
  Math.ceil((new Date(PATENT_PCT_DEADLINE) - new Date()) / 86400000);

export const PatentFiledBadge = ({ className = "" }) => (
  <span
    data-testid="patent-filed-badge"
    title={`UK patent application ${PATENT_APP_NO} — filed 09 Jun 2026 (UKIPO acknowledged)`}
    className={`inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700 ${className}`}
  >
    <ShieldCheck size={13} />
    Patent filed · {PATENT_APP_NO}
  </span>
);

export const PctDeadlineReminder = ({ className = "" }) => {
  const days = pctDaysRemaining();
  const urgent = days <= 90;
  return (
    <div
      data-testid="pct-deadline-reminder"
      title="File the combined PCT application claiming UK priority before this date."
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium ${
        urgent
          ? "border-amber-300 bg-amber-50 text-amber-800"
          : "border-ek-purple/20 bg-ek-purple/5 text-ek-purple"
      } ${className}`}
    >
      <CalendarClock size={13} />
      PCT filing deadline · 09 Jun 2027
      {days > 0 ? ` · ${days} days remaining` : " · OVERDUE"}
    </div>
  );
};

// Public-facing trust strip for the login/landing page. The application *number* is
// safe to disclose (it reveals no claim detail); the specification stays admin-gated.
export const IpProtectedStrip = ({ tone = "dark", className = "" }) => {
  const dark = tone === "dark";
  return (
    <div
      data-testid="ip-protected-strip"
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold ${
        dark
          ? "border-white/15 bg-white/5 text-white/80"
          : "border-emerald-300 bg-emerald-50 text-emerald-700"
      } ${className}`}
    >
      <ShieldCheck size={14} className={dark ? "text-ek-lilac" : "text-emerald-600"} />
      IP protected · UK patent application {PATENT_APP_NO} filed
    </div>
  );
};
